import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@/features/auth/context/authProvider'
import { resetPassword } from '@/features/auth/services/authService'
import Button from '@/shared/components/Button/Button'
import { useSnackbar } from '@/shared/components/Snackbar/SnackbarProvider'

/**
 * A new password by email: nothing to type here, so nothing to save. Where
 * the link went is told in the banner once it is sent.
 */
function PasswordLinkField() {
  const { t } = useTranslation()
  const { currentUser } = useAuth()
  const { showSnackbar } = useSnackbar()
  const [isSending, setIsSending] = useState(false)
  const email = currentUser?.email ?? ''

  const send = async () => {
    setIsSending(true)
    try {
      await resetPassword(email)
      showSnackbar(
        t('ALERTS.PASSWORD_LINK_SUCCESS.TITLE'),
        t('ALERTS.PASSWORD_LINK_SUCCESS.DESCRIPTION', { email }),
        'success'
      )
    } catch {
      showSnackbar(
        t('ALERTS.PASSWORD_LINK_ERROR.TITLE'),
        t('ALERTS.PASSWORD_LINK_ERROR.DESCRIPTION'),
        'error'
      )
    } finally {
      setIsSending(false)
    }
  }

  return (
    <Button
      label={t('SETTINGS.ACCOUNT.PASSWORD_CHANGE')}
      variant="text"
      color="primary"
      icon="las la-key icon-medium"
      disabled={isSending || !email}
      onClick={send}
    />
  )
}

export default PasswordLinkField
